<template>
    <div class="login-container">
        <logo></logo>
        <div class="wtw-container">
            <form class="wtw-form">
                <div class="input-container">
                    <input type="text"
                           placeholder="Email"
                           name="email"
                           v-model="user.email"
                           @input="errorMessage = null"
                    />
                    <span v-show="errors.has('email')" class="error-message">{{ errors.first('email') }}</span>
                </div>
                <div class="input-container">
                    <input type="password"
                           placeholder="Password"
                           name="password"
                           v-validate="'required'"
                           v-model="user.password"
                           @input="errorMessage = null"
                    />
                    <span v-show="errors.has('password')" class="error-message">{{ errors.first('password') }}</span>
                </div>
                <div class="input-container" style="margin-left:20px">
                    <input type="checkbox"
                        name="remember-me"
                        id="remember-me"
                        class="ios-toggle"
                        v-model="user.rememberMe"
                    />
                    <label for="remember-me" class="checkbox-label" data-label="Remember me"></label>
                </div>
                <div @click.stop="logUserIn(user)"
                     class="button pink"
                     :class="{disabled: errors.has('password') || errors.has('email')}"
                >
                    Log In
                </div>
                <router-link class="password-reset" to="/account/send-reset-email">
                    Forgot Password?
                </router-link>
            </form>
            <span v-show="errorMessage" class="error-message">{{ errorMessage }}</span>
        </div>
        <div @click.stop="$router.go(-1)" class="back-button">
            Back
        </div>
        <transition name="fade">
            <div v-show="loggingIn" class="loading-overlay">
                <loader></loader>
            </div>
        </transition>
    </div>
</template>

<script>

    import Logo from '../header/logo.vue';
    import {mapGetters} from "vuex";
    import Loader from '../common/loader.vue';

    export default {
        data(){
            return {
                loggingIn: false,
                errorMessage: null
            }
        },
        components: {Loader, Logo},
        computed: {
            ...mapGetters({
                user: 'auth/getUser',
                authToken: 'auth/getAuthToken'
            })
        },
        methods: {
            logUserIn(user){
                this.loggingIn = true;
                this.$store.dispatch('auth/authenticate', {
                    email: user.email,
                    password: user.password,
                    rememberMe: user.rememberMe
                }).then((response) => {
                    if (this.authToken) {
                        this.$router.push({path: '/'});
                        this.$store.dispatch({
                            type: "cart/fetchCartProducts",
                        });
                        this.$store.dispatch("quizzes/fetchQuizProfile", true);
                        this.$store.dispatch({
                            type: "config/fetchCredentials",
                        });
                    } else {
                        this.loggingIn = false;
                        this.errorMessage = 'Invalid Auth Token, please try again.';
                    }
                }).catch(response => {
                    this.loggingIn = false;
                    this.errorMessage = response;
                });
            }
        }
    }
</script>